import { countOccupantsForFlights } from './occupancyUtils'

export function getFlightPricePerPerson(totalFlightPrice: number | undefined, rooms: Array<App.Occupants>) {
  if (!totalFlightPrice) {
    return undefined
  }

  const flightOccupants = countOccupantsForFlights(rooms)
  const totalPeople = flightOccupants.adults + flightOccupants.children + flightOccupants.infants

  return totalPeople > 0 ? totalFlightPrice / totalPeople : undefined
}
